import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import * as CryptoJS from 'crypto-js'
import { Observable } from 'rxjs/internal/Observable'
import { environment } from './../../environments/environment'
@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  options: any
  encryptedData: any

  constructor(private http: HttpClient) {
    this.encryptedData = localStorage.getItem('adminInfo')
    if (this.encryptedData) {
      const user: any = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      const headers: any = new HttpHeaders({
        Authorization: user.tokenType + ' ' + user.accessToken,
      })
      this.options = { headers }
    }
  }

  updateToken(): void {
    this.encryptedData = localStorage.getItem('adminInfo')
    if (this.encryptedData) {
      const user: any = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretKey
        ).toString(CryptoJS.enc.Utf8)
      )
      const headers: any = new HttpHeaders({
        Authorization: user.tokenType + ' ' + user.accessToken,
      })
      this.options = { headers }
    }
  }

  updateProfile(data: any): Observable<any> {
    this.updateToken()
    let type: any
    const sendData: any = { email: data.email }
    if (data.userType === 'brand') {
      if (data.logo) {
        sendData.logo = data.logo
      }
      if (data.name) {
        sendData.name = data.name
      }
      if (data.username) {
        sendData.username = data.username
      }
      if (data.mobile_number) {
        sendData.mobile_number = data.mobile_number
      }
      if (data.website_link) {
        sendData.website_link = data.website_link
      }
      type = 'brandAdmin/'
    } else {
      if (data.image) {
        sendData.image = data.image;
      }
      type = 'admin/'
      if (data.first_name) {
        sendData.first_name = data.first_name
      }
      if (data.mobile_number) {
        sendData.mobile_number = data.mobile_number
      } else {
        sendData.mobile_number = ''
      }
      if (data.last_name) {
        sendData.last_name = data.last_name
      }
    }

    return this.http.patch(
      environment.apiUrl + type + 'profile/',
      sendData,
      this.options
    )
  }
  changePassword(data: any): Observable<any> {
    this.updateToken()
    const sendData: any = {
      current_password: data.old_password,
      new_password: data.password,
    }

    return this.http.post(
      environment.apiUrl + 'password/change/',
      sendData,
      this.options
    )
  }

  uploadProfile(data: any, type: any): Observable<any> {
    this.updateToken()
    const headers: any = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded')
    const formData: any = new FormData()

    if (type !== 'brand') {
      type = 'admin'
      formData.append('image', data, data.name)
    } else {

      formData.append('image', data, data.name)
    }

    return this.http.patch(
      environment.apiUrl + type + '/profile/image/',
      formData,
      this.options
    )
  }
  uploadDoc(data: any): Observable<any> {
    this.updateToken()
    const headers: any = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded')
    const formData: any = new FormData()

    formData.append('document', data.file, data.file.name)
    formData.append('title', data.title)

    return this.http.post(
      environment.apiUrl + 'brands/document/',
      formData,
      this.options
    )
  }

  deleteDoc(id: any): Observable<any> {
    this.updateToken()
    const headers: any = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded')
    return this.http.delete(
      environment.apiUrl + 'brands/document/delete/' + id + '/',
      this.options
    )
  }
  getContent(): Observable<any> {
    this.updateToken()
    return this.http.get(
      environment.apiUrl +
      'information/',
      this.options
    )
  }
}
